import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectClientCreationDateModified = (state: StoreSchema) => {
    return state.client.cachedClient.creationDate?.split('T')?.[0]
}
